module.exports = __webpack_public_path__ + "img/xcxma.62b19ce4.jpg";